// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2xf75","select":"Header_select__33yUO","clinic":"Header_clinic__3Y1iO"};